import { render, staticRenderFns } from "./ConsultationList.vue?vue&type=template&id=5bf19cd0&scoped=true"
import script from "./ConsultationList.vue?vue&type=script&lang=js"
export * from "./ConsultationList.vue?vue&type=script&lang=js"
import style0 from "./ConsultationList.vue?vue&type=style&index=0&id=5bf19cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf19cd0",
  null
  
)

export default component.exports